// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3cUQt","container":"styles_container__2kUlo","icon":"styles_icon__1-9Ns"};